import {Component, Input} from '@angular/core';
import {MatIcon} from '@angular/material/icon';
import {CurrencyPipe, DatePipe, NgClass} from '@angular/common';
import {DriverReq, PassengerRequest} from '../../interfaces/miranda.interface';
import {LocTzPipe} from '../../pipes/loc-tz.pipe';

@Component({
  selector: 'app-trip-card',
  imports: [
    MatIcon,
    CurrencyPipe,
    DatePipe,
    NgClass,
    LocTzPipe
  ],
  templateUrl: './trip-card.component.html',
  styleUrl: './trip-card.component.scss'
})
export class TripCardComponent {
  @Input() userType!: 'passenger' | 'driver' | 'dispatcher';
  @Input() driverReq!: DriverReq;
  @Input() passengerReq!: PassengerRequest;
  public timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

}
